export default {"src":"/_next/static/media/list-gray.2c8b638e.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};